import { createAction, props } from '@ngrx/store'
import { TokenAPIModel } from 'src/app/models/api.model'

const prefix = '[auth]'

export const start_login = createAction(`${prefix} start_login`, props<{ email: string; password: string }>())
export const start_login_with_otp = createAction('start_login_with_otp', props<{ email: string; otp: string }>())
export const login_success = createAction(`${prefix} login_success`, props<{ bearer_token: string }>())
export const login_failed = createAction(`${prefix} login_failed`, props<{ bearer_token: string }>())

export const start_logout = createAction(`${prefix} start_logout`, props<any>())
export const logout_success = createAction(`${prefix} logout_success`, props<{ data: any }>())
export const logout_failed = createAction(`${prefix} logout_failed`, props<{ data: any }>())

export const start_select_client = createAction(
  `${prefix} start_select_client`,
  props<{ groupId: string; entityIds: string[]; callback: Function }>()
)
export const select_client_success = createAction(
  `${prefix} select_client_success`,
  props<{ callback: Function; tokenModel: TokenAPIModel }>()
)
export const select_client_failed = createAction(`${prefix} select_client_failed`, props<{ error: any }>())

export const start_forgot_password = createAction(
  'start_forgot_password',
  props<{ email: string; callback: Function }>()
)

export const forgot_password_success = createAction('forgot_password_success', props<{ callback: Function }>())

export const forgot_password_failed = createAction('forgot_password_failed', props<{ error: string }>())

export const start_reset_password_with_password = createAction(
  'start_reset_password_with_password',
  props<{ oldPassword: string; newPassword: string; callback: Function }>()
)

export const reset_password_with_password_success = createAction(
  'reset_password_with_password_success',
  props<{ callback: Function }>()
)

export const reset_password_with_password_failed = createAction(
  'reset_password_with_password_failed',
  props<{ error: string }>()
)

export const start_sso_login = createAction('start_sso_login', props<{ id_token: string; companyDomain: string }>())
